import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import analytics from '../lib/tracking';

export default function AnnouncementBar() {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchAnn = async () => {
      try {
        // Use relative URL so it works in all environments (ingress routes /api/* to backend)
        const resp = await fetch('/api/announcement');
        if (resp.ok) {
          const data = await resp.json();
          if (data.enabled && data.text) {
            const dismissedText = sessionStorage.getItem('dismissed_announcement');
            if (dismissedText !== data.text) {
              setAnnouncement(data);
            }
          }
        }
      } catch {}
    };
    fetchAnn();
  }, []);

  if (!announcement || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('dismissed_announcement', announcement.text);
    analytics.announcementDismissed(announcement.text);
  };

  return (
    <div className="w-full py-2.5 px-4 text-center relative" style={{ background: 'linear-gradient(135deg, #FF6A2A 0%, #FF4500 100%)' }}>
      <p className="text-sm font-bold text-white">
        {announcement.link ? (
          <a href={announcement.link} className="hover:underline">{announcement.text}</a>
        ) : (
          announcement.text
        )}
      </p>
      <button onClick={handleDismiss} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
